export default __webpack_public_path__ + "media/trail/icons-controls-3d-3a664188.svg";